import { ConfigurationFacade } from '~/app/core/state/configuration/configuration.facade';
import { FaviconUtilsService } from '~/app/shared/services/favicon-utils/favicon-utils.service';

export function faviconUtilsFactory(faviconService: FaviconUtilsService, configurationFacade: ConfigurationFacade) {
    return () => faviconService.setFavicon(configurationFacade.getThemeLogosSnapshot()?.faviconUrl ?? undefined);
}
